<template>
  <div class="row gy-0 gx-10">
    <!--begin::Col-->
    <div class="col-xl-12">
      <!--begin::General Widget 1-->
      <div class="mb-10">
        <div class="">
          <div class="card-header border-0">
            <h3 class="card-title align-items-center flex-column">
              <span class="card-label page-title fw-bolder fs-3 mb-1"
                >Order a Barrel</span
              >
              <!-- <span class="text-muted mt-1 fw-bold fs-7">Active Barrels</span> -->
            </h3>
          </div>
        </div>

        <OrderBarrelFormProgress v-model="formProgress" />

        <div class="spacer-y-10"></div>
        <div v-if="barrelOptionsLoading" class="align-center">
          <v-progress-circular
            indeterminate
            color="primary"
            class="ml-2"
            size="26"
            width="2"
          ></v-progress-circular>
        </div>
        <form v-if="!barrelOptionsLoading">
          <OrderBarrelOptionsCarousel
            :loading="barrelOptionsLoading"
            :order="order"
            :barrelSizeOptions="barrelOptionsArray"
            :barrelOptions="barrelOptions"
          />

          <div class="card col align-center col-sm-10 col-md-8 col-xl-6 my-7">
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->
                <div
                  class="tab-pane fade show active"
                  id="kt_table_widget_5_tab_1"
                >
                  <label class="d-flex flex-stack cursor-pointer my-6">
                    <!--begin:Label-->
                    <span class="d-flex align-items-center me-2">
                      <span class="d-flex flex-column">
                        <span class="fw-bolder fs-6">Delivery in Jamaica</span>
                      </span>
                      <!--end:Info-->
                    </span>

                    <!--end:Label-->
                    <!--begin:Input-->
                    <span
                      class="form-check form-check-custom form-check-solid is-valid"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="order.deliveryMethod"
                        value="delivery"
                      />
                    </span>
                    <!--end:Input-->
                  </label>

                  <div
                    v-if="order.deliveryMethod == 'delivery'"
                    class="fv-row mb-10 fv-plugins-icon-container"
                  >
                    <!--begin::Label-->
                    <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                      <span class="required">Address Line 1</span>
                    </label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input
                      type="text"
                      class="form-control form-control-lg form-control-solid"
                      v-model="order.deliveryAddress.line1"
                      placeholder=""
                    />
                    <label
                      class="d-flex align-items-center fs-5 fw-bold mt-6 mb-2"
                    >
                      <span>Address Line 2</span>
                    </label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input
                      type="text"
                      class="form-control form-control-lg form-control-solid"
                      v-model="order.deliveryAddress.line2"
                      placeholder=""
                    />
                    <div class="row">
                      <div class="col-6">
                        <label
                          class="d-flex align-items-center fs-5 fw-bold mt-6"
                        >
                          <span class="required">Town</span>
                        </label>
                        <!--end::Label-->
                        <!--begin::Input-->
                        <input
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          v-model="order.deliveryAddress.town"
                          placeholder=""
                        />
                      </div>
                      <div class="col-6">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-5 fw-bold mt-6"
                        >
                          <span class="required">Parish</span>
                        </label>
                        <!--end::Label-->
                        <select
                          class="form-control form-control-lg form-control-solid"
                          v-model="order.deliveryAddress.parish"
                        >
                          <option
                            v-for="location in parishes"
                            :key="location"
                            :value="location"
                          >
                            {{ location }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="fv-plugins-message-container invalid-feedback"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="card col align-center col-sm-10 col-md-8 col-xl-6 my-7"
            style="background-color: transparent; border: 0px"
          >
            <div class="card-body py-6 checkboxes">
              <label class="d-flex flex-stack cursor-pointer">
                <span class="d-flex align-items-center me-2">
                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6"
                      >Agree to the
                      <a
                        @click.prevent="showProhibitedItemsModal = true"
                        class="ms-1 link-primary text-pink"
                        target="_blank"
                        >prohibited items terms and agreement</a
                      >
                    </span>
                  </span>
                </span>

                <span
                  class="form-check form-check-custom form-check-solid is-valid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="category"
                    v-model="terms"
                  />
                </span>
              </label>

              <label class="d-flex flex-stack cursor-pointer">
                <span class="d-flex align-items-center me-2">
                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6"
                      >Agree to
                      <a
                        @click.prevent="showSecondaryPackagingModal = true"
                        class="ms-1 link-primary text-pink"
                        target="_blank"
                        >remove secondary packaging</a
                      >
                    </span>
                  </span>
                </span>

                <span
                  class="form-check form-check-custom form-check-solid is-valid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="category"
                    v-model="secondaryPackaging"
                  />
                </span>
              </label>

              <label class="d-flex flex-stack cursor-pointer">
                <span class="d-flex align-items-center me-2">
                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6"
                      >Agree to
                      <a
                        @click.prevent="showTimeLimitModal = true"
                        class="ms-1 link-primary text-pink"
                        target="_blank"
                        >30-day time limit for barrel shipment</a
                      >
                    </span>
                  </span>
                </span>

                <span
                  class="form-check form-check-custom form-check-solid is-valid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="category"
                    v-model="timeLimit"
                  />
                </span>
              </label>

              <label class="d-flex flex-stack cursor-pointer">
                <span class="d-flex align-items-center me-2">
                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6"
                      >Agree to
                      <a
                        @click.prevent="showAdditionalBarrelModal = true"
                        class="ms-1 link-primary text-pink"
                        target="_blank"
                        >alternative shipping where necessary</a
                      >
                    </span>
                  </span>
                </span>

                <span
                  class="form-check form-check-custom form-check-solid is-valid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="category"
                    v-model="additionalBarrel"
                  />
                </span>
              </label>
            </div>
          </div>

          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group>
              <div
                class="py-3"
                style="
                  min-width: 100%;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <b-form-radio
                  :value="true"
                  v-model="order.removeRetailPackaging"
                  style="max-width: fit-content; margin: 0"
                >
                  <span class="fw-bolder fs-6" style="padding-left: 0.5rem">
                    Agree to
                    <a
                      @click.prevent="showRemoveRetailPackagingModal = true"
                      class="ms-1 link-primary text-pink"
                      target="_blank"
                      >remove retail packaging</a
                    >
                  </span>
                </b-form-radio>
                <b-form-radio
                  :value="false"
                  v-model="order.removeRetailPackaging"
                  style="max-width: fit-content; margin: 0; padding-left: 3rem"
                >
                  <span class="fw-bolder fs-6" style="padding-left: 0.5rem">
                    Do not agree to
                    <a
                      @click.prevent="showKeepRetailPackagingModal = true"
                      class="ms-1 link-primary text-pink"
                      target="_blank"
                      >remove retail packaging</a
                    >
                  </span>
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-form-group>

          <div
            class="card plain-card col-10 align-center col-sm-8 col-md-6 col-xl-4 my-7 mt-15"
          >
            <button
              @click="$emit('next')"
              :class="nextBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
            >
              Next
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <!-- mb-10 -->
      <!--end::General Widget 1-->
    </div>
    <!--end::Col-->
    <!--begin::Col-->

    <!--end::Col-->
    <ProhibitedItemsDisplay
      :show="showProhibitedItemsModal"
      @close="showProhibitedItemsModal = false"
    />
    <RemoveSecondaryPackagingDisplay
      :show="showSecondaryPackagingModal"
      @close="showSecondaryPackagingModal = false"
    />
    <TimeLimitDisplay
      :show="showTimeLimitModal"
      @close="showTimeLimitModal = false"
    />

    <RemoveRetailPackagingDisplay
      :show="showRemoveRetailPackagingModal"
      @close="showRemoveRetailPackagingModal = false"
    />

    <KeepRetailPackagingDisplay
      :show="showKeepRetailPackagingModal"
      @close="showKeepRetailPackagingModal = false"
    />

    <AdditionalBarrelRecommendation
      :show="showAdditionalBarrelModal"
      @close="showAdditionalBarrelModal = false"
    />
  </div>
</template>

<script>
import Vue from "vue";
import pickupLocations from "@/config/pickup.json";
import parishes from "@/config/parish.json";
import { ApiService } from "@/services/ApiService";
import ProhibitedItemsDisplay from "@/components/ProhibitedItemsDisplay.vue";
import TimeLimitDisplay from "@/components/TimeLimitDisplay.vue";
import OrderBarrelOptionsCarousel from "@/components/OrderBarrelOptionsCarousel.vue";
import { error } from "@/services/LoggerService";
import RemoveSecondaryPackagingDisplay from "@/components/RemoveSecondaryPackagingDisplay.vue";
import OrderBarrelFormProgress from "@/components/OrderBarrelFormProgress.vue";
import RemoveRetailPackagingDisplay from "@/components/RemoveRetailPackagingDisplay.vue";
import KeepRetailPackagingDisplay from "@/components/KeepRetailPackagingDisplay.vue";
import AdditionalBarrelRecommendation from "@/components/AdditionalBarrelRecommendation.vue";

export default Vue.extend({
  name: "OrderBarrelDetails",
  components: {
    ProhibitedItemsDisplay,
    OrderBarrelOptionsCarousel,
    RemoveSecondaryPackagingDisplay,
    TimeLimitDisplay,
    OrderBarrelFormProgress,
    RemoveRetailPackagingDisplay,
    KeepRetailPackagingDisplay,
    AdditionalBarrelRecommendation,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    formProgress: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      barrelOptionsLoading: false,
      barrelOptions: [],
      additionalCosts: {
        clearanceCost: 0,
      },
      pickupCost: 0,
      defaultDeliveryCost: 0,
      deliveryCostMap: {},
      terms: false,
      secondaryPackaging: false,
      timeLimit: false,
      additionalBarrel: false,
      pickupLocations: pickupLocations,
      parishes: parishes,
      showProhibitedItemsModal: false,
      showTimeLimitModal: false,
      showAdditionalBarrelModal: false,
      showSecondaryPackagingModal: false,
      showRemoveRetailPackagingModal: false,
      showKeepRetailPackagingModal: false,
    };
  },
  computed: {
    order: {
      get() {
        return this.value;
      },
    },
    barrelOptionsArray() {
      return Object.keys(this.barrelOptions);
    },
    pickupLocationNames() {
      return this.pickupLocations.map((l) => l.name);
    },
    shippingCost() {
      return this.getShippingCost(this.order.barrelSize, this.order.capacity);
    },
    barrelCost() {
      return this.getBarrelCost(this.order.barrelSize, this.order.capacity);
    },
    deliveryCost() {
      try {
        if (!this.order.deliveryMethod) {
          return 0;
        }

        if (this.order.deliveryMethod === "pickup") {
          return this.additionalCosts.pickupCost;
        }

        const parish = this.order.deliveryAddress?.parish;

        if (!parish || !this.deliveryCostMap[parish]) {
          return this.defaultDeliveryCost;
        }

        return this.deliveryCostMap[parish];
      } catch (e) {
        error(e);
      }
      return 0;
    },
    nextBtnClass() {
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (
        !this.order.barrelSize ||
        !this.order.capacity ||
        this.deliveryMethodCheck(this.order.deliveryMethod) ||
        !this.terms ||
        !this.secondaryPackaging ||
        !this.timeLimit ||
        !this.additionalBarrel ||
        !(
          this.order.removeRetailPackaging == true ||
          this.order.removeRetailPackaging == false
        )
      )
        return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    },
  },
  methods: {
    getShippingCost(size, capacity) {
      try {
        return this.getSelectedBarrel(size, capacity).shippingCost;
      } catch (e) {
        return 0;
      }
    },
    getBarrelCost(size, capacity) {
      try {
        return this.getSelectedBarrel(size, capacity).barrelCost;
      } catch (e) {
        return 0;
      }
    },
    getSelectedBarrel(size, capacity) {
      const barrelCapacityOptions = this.barrelOptions[size];
      return barrelCapacityOptions.find((b) => b.capacity == capacity);
    },
    deliveryMethodCheck(deliveryMethod) {
      if (deliveryMethod === "pickup") return !this.order.pickupLocation;
      return (
        !this.order.deliveryAddress.line1 ||
        !this.order.deliveryAddress.town ||
        !this.order.deliveryAddress.parish
      );
    },
    async retrieveBarrelOptions() {
      const response = await ApiService.Instance.getBarrelOptions();
      const options = response.barrelOptions;

      this.additionalCosts.clearanceCost = response.clearanceCost;
      this.additionalCosts.deliveryGctPercentage =
        response.deliveryGctPercentage;
      this.defaultDeliveryCost = response.defaultDeliveryCost;
      this.deliveryCostMap = response.deliveryCostMap;
      this.pickupCost = response.pickupCost;

      this.barrelOptions = options.reduce((options, barrelOption) => {
        if (!options[barrelOption.size]) {
          options[barrelOption.size] = [{ ...barrelOption }];
          return options;
        }

        options[barrelOption.size].push({ ...barrelOption });
        return options;
      }, {});
    },
  },
  watch: {
    order: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
    additionalCosts: {
      handler(value) {
        this.$emit("update:additionalCosts", value);
      },
      deep: true,
    },
    shippingCost: {
      handler(value) {
        this.order.shippingCost = value;
      },
    },
    barrelCost: {
      handler(value) {
        this.order.barrelCost = value;
      },
    },
    deliveryCost: {
      handler(value) {
        this.order.deliveryCost = value;
      },
    },
  },
  async beforeMount() {
    this.barrelOptionsLoading = true;
    await this.retrieveBarrelOptions();
    this.barrelOptionsLoading = false;
  },
});
</script>

<style>
.checkboxes > * {
  margin-bottom: 0.7rem;
}
</style>
